import React, { useRef, useEffect, useState } from "react";
import { classNames } from "utils/utils";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonLabel,
  IonTitle,
  IonToolbar,
  IonModal,
  IonHeader,
  IonFooter,
} from "@ionic/react";
import { useGame } from "context/gameContext";
import { collection, query, where, orderBy, limit } from "firebase/firestore";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { useModalContext } from "context/modalContext";

const SiteBanner = () => {
  const {
    state: { premium },
  } = useGame();
  const firestore = useFirestore();
  const modal = useRef(null);

  const { openPaywallModal } = useModalContext();
  const subscribeModal = () => {
    openPaywallModal();
  };

  const [message, setMessage] = useState([]);

  function dismiss() {
    modal.current?.dismiss();
  }

  const bannerCollection = collection(firestore, "bannerMessages");
  const bannerQuery = query(
    bannerCollection,
    where("visible", "==", true),
    orderBy("createdAt", "desc"),
    limit(1)
  );

  // get general game settings
  const { status: bannerStatus, data: bannerData } = useFirestoreCollectionData(
    bannerQuery,
    {
      idField: "id",
    }
  );

  useEffect(() => {
    if (bannerData && bannerData.length) {
      //Set the data from the first doc in bannerData to the message state

      setMessage(bannerData);
    }
  }, [bannerData]);

  const hideIfPremium = message[0] && message[0].getPremium && premium;

  return message.length && message[0] && !hideIfPremium ? (
    <IonToolbar
      className={classNames(
        message[0].critical ? "bg-yellow-500" : "bg-white",
        "transparent"
      )}
    >
      <IonLabel slot="start">
        <div className="grid w-full overflow-hidden pl-2 text-xs">
          <div className="truncate whitespace-nowrap font-semibold">
            {message[0]?.title}
          </div>
          <div className="truncate whitespace-nowrap">
            {message[0]?.subtitle}
          </div>
        </div>
      </IonLabel>
      <IonButtons slot="end">
        <IonButton
          detail="false"
          expand="block"
          className="customButton noOpacity "
          id="open-modal"
          mode="ios"
          fill="outline"
          color="dark"
        >
          <IonLabel className=" text-black text-sm">Read</IonLabel>
        </IonButton>
      </IonButtons>
      <IonModal mode="ios" ref={modal} trigger="open-modal">
        <IonHeader>
          <IonToolbar>
            <IonTitle>{message[0]?.title}</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => dismiss()}>Close</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding ">
          <div className="flex flex-col w-full items-center justify-center p-4">
            {message[0]?.content}
          </div>
        </IonContent>
        {message[0].getPremium && !premium && (
          <IonFooter mode="ios" className=" py-2 px-3.5">
            <div className="flex gap-0.5 flex-col">
              <IonButton
                mode="ios"
                fill="solid"
                color="success"
                onClick={subscribeModal}
                expand="block"
                className="customButtonNew rounded-md p-0"
              >
                <IonLabel className="!text-black">Subscribe</IonLabel>
              </IonButton>
              <IonButton
                mode="ios"
                fill="outline"
                color="dark"
                onClick={dismiss}
                expand="block"
                className="customButtonNew rounded-md p-0"
              >
                <IonLabel className="!text-black">Cancel</IonLabel>
              </IonButton>
            </div>
          </IonFooter>
        )}
      </IonModal>
    </IonToolbar>
  ) : (
    <></>
  );
};

export default SiteBanner;
